export default __webpack_public_path__ + "static/media/1857.c7d0c8e8.png";